// Copyright (c) 2026 Interpaste, all rights reserved
// @author: norelock <https://gitlab.com/mvvnlight>

import { PlayerRuntimeController } from './controllers'

const runtime = new PlayerRuntimeController()
addEventListener('message', (event) => runtime.onMessage(event), false)
